module.exports = __webpack_public_path__ + "fonts/Gilroy-SemiBold.ttf?05bdf30b8aaa10683c19e73dd0c428da";